import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);
const PREFIX = 'beeshop';
export const beeshop = [
  {
    path: "/" + PREFIX,
    name: PREFIX,
    meta: {
      breadCrumb: "dashboard",
      roles: ""
    },
    component: () => import("../views/"+ PREFIX +"/dashboard.vue")
  },
  /** ==== Order management ======= */
  {
    path: "/" + PREFIX + "/agri-input/order-management",
    name: PREFIX + ".agri-input.order-management",
    meta: {
      breadCrumb: "orderManagement",
      roles: ""
    },
    component: () => import("../views/"+ PREFIX +"/order-management.vue")
  },
  {
    path: "/" + PREFIX + "/agri-input/order-management/order",
    name: PREFIX + ".agri-input.order-management.order",
    meta: {
      breadCrumb: "order",
      roles: ""
    },
    component: () => import("../views/"+ PREFIX +"/orders/order.vue")
  },
  {
    path: "/" + PREFIX + "/agri-input/order-management/print",
    name: PREFIX + ".agri-input.order-management.print",
    meta: {
      breadCrumb: "print",
      roles: ""
    },
    component: () => import("../views/"+ PREFIX +"/orders/print.vue")
  },
  {
    path: "/" + PREFIX + "/agri-input/order-management/order-list",
    name: PREFIX + ".agri-input.order-management.order-list",
    meta: {
      breadCrumb: "orderList",
      roles: ""
    },
    component: () => import("../views/"+ PREFIX +"/orders/orderList.vue")
  },
  {
    path: "/" + PREFIX + "/agri-input/order-management/delivery-board",
    name: PREFIX + ".agri-input.order-management.delivery-board",
    meta: {
      breadCrumb: "deliveryBoard",
      roles: ""
    },
    component: () => import("../views/"+ PREFIX +"/orders/deliveryBoard.vue")
  },
  {
    path: "/" + PREFIX + "/agri-input/order-management/order-payment",
    name: PREFIX + ".agri-input.order-management.order-payment",
    meta: {
      breadCrumb: "invoice",
      roles: ""
    },
    component: () => import("../views/"+ PREFIX +"/orders/orderPaymentBoard.vue")
  },
  {
    path: "/" + PREFIX + "/agri-input/order-management/order-payment-board",
    name: PREFIX + ".agri-input.order-management.order-payment-board",
    meta: {
      breadCrumb: "invoice",
      roles: ""
    },
    component: () => import("../views/"+ PREFIX +"/orders/orderPaymentBoard.vue")
  },
  {
    path: "/" + PREFIX + "/agri-input/order-management/order-transaction-paid",
    name: PREFIX + ".agri-input.order-management.order-transaction-paid",
    meta: {
      breadCrumb: "invoice",
      roles: ""
    },
    component: () => import("../views/"+ PREFIX +"/orders/orderTransactionPaid.vue")
  },
  {
    path: "/" + PREFIX + "/agri-input/order-management/print-invoice-farmer",
    name: PREFIX + ".agri-input.order-management.print-invoice-farmer",
    meta: {
      breadCrumb: "print",
      roles: ""
    },
    component: () => import("../views/"+ PREFIX +"/orders/printInvoiceFarmer.vue")
  },
  {
    path: "/" + PREFIX + "/agri-input/order-management/print-invoice-shop",
    name: PREFIX + ".agri-input.order-management.print-invoice-shop",
    meta: {
      breadCrumb: "print",
      roles: ""
    },
    component: () => import("../views/"+ PREFIX +"/orders/printInvoiceShop.vue")
  },
  /** ==== Order management ======= */

  /** ==== Farmer Order management ======= */
  {
    path: "/" + PREFIX + "/agri-input/order-farmer-management/order",
    name: PREFIX + ".agri-input.order-farmer-management.order",
    meta: {
      breadCrumb: "order",
      roles: ""
    },
    component: () => import("../views/"+ PREFIX +"/farmers/order.vue")
  },
  {
    path: "/" + PREFIX + "/agri-input/order-farmer-management/order-list",
    name: PREFIX + ".agri-input.order-farmer-management.order-list",
    meta: {
      breadCrumb: "order",
      roles: ""
    },
    component: () => import("../views/"+ PREFIX +"/farmers/orderList.vue")
  },
  {
    path: "/" + PREFIX + "/agri-input/order-farmer-management/print-invoice-farmer",
    name: PREFIX + ".agri-input.order-farmer-management.print-invoice-farmer",
    meta: {
      breadCrumb: "print",
      roles: ""
    },
    component: () => import("../views/"+ PREFIX +"/farmers/printInvoiceFarmer.vue")
  },
  {
    path: "/" + PREFIX + "/agri-input/order-farmer-management/product-take-out",
    name: PREFIX + ".agri-input.order-farmer-management.product-take-out",
    meta: {
      breadCrumb: "productTakeOut",
      roles: ""
    },
    component: () => import("../views/"+ PREFIX +"/farmers/getProductTakeOut.vue")
  },
  {
    path: "/" + PREFIX + "/agri-input/order-farmer-management/farmer-payment-board",
    name: PREFIX + ".agri-input.order-farmer-management.farmer-payment-board",
    meta: {
      breadCrumb: "payment",
      roles: ""
    },
    component: () => import("../views/"+ PREFIX +"/farmers/farmerPaymentBoard.vue")
  },
  {
    path: "/" + PREFIX + "/agri-input/order-farmer-management/farmer-transaction-paid",
    name: PREFIX + ".agri-input.order-farmer-management.farmer-transaction-paid",
    meta: {
      breadCrumb: "payment",
      roles: ""
    },
    component: () => import("../views/"+ PREFIX +"/farmers/farmerTransactionPaid.vue")
  },
  /** ==== End Farmer Order management ======= */
  
  /** ==== Sale management ======= */
  {
    path: "/" + PREFIX + "/agri-input/sale-management/sale",
    name: PREFIX + ".agri-input.sale-management.sale",
    meta: {
      breadCrumb: "sale",
      roles: ""
    },
    component: () => import("../views/"+ PREFIX +"/sales/sale.vue")
  },
  {
    path: "/" + PREFIX + "/agri-input/sale-management/print",
    name: PREFIX + ".agri-input.sale-management.print",
    meta: {
      breadCrumb: "print",
      roles: ""
    },
    component: () => import("../views/"+ PREFIX +"/sales/print.vue")
  },
  {
    path: "/" + PREFIX + "/agri-input/sale-management/delivery-note",
    name: PREFIX + ".agri-input.sale-management.delivery-note",
    meta: {
      breadCrumb: "deliveryNote",
      roles: ""
    },
    component: () => import("../views/"+ PREFIX +"/sales/deliveryNoteList.vue")
  },
  {
    path: "/" + PREFIX + "/agri-input/sale-management/sale-payment-board",
    name: PREFIX + ".agri-input.sale-management.sale-payment-board",
    meta: {
      breadCrumb: "invoice",
      roles: ""
    },
    component: () => import("../views/"+ PREFIX +"/sales/salePaymentBoard.vue")
  },
  {
    path: "/" + PREFIX + "/agri-input/sale-management/sale-transaction-paid",
    name: PREFIX + ".agri-input.sale-management.sale-transaction-paid",
    meta: {
      breadCrumb: "paidInvoice",
      roles: ""
    },
    component: () => import("../views/"+ PREFIX +"/sales/saleTransactionPaid.vue")
  },
  {
    path: "/" + PREFIX + "/agri-input/sale-management/print-invoice-farmer",
    name: PREFIX + ".agri-input.sale-management.print-invoice-farmer",
    meta: {
      breadCrumb: "print",
      roles: ""
    },
    component: () => import("../views/"+ PREFIX +"/sales/printInvoiceFarmer.vue")
  },
  {
    path: "/" + PREFIX + "/agri-input/sale-management/print-invoice-shop",
    name: PREFIX + ".agri-input.sale-management.print-invoice-shop",
    meta: {
      breadCrumb: "print",
      roles: ""
    },
    component: () => import("../views/"+ PREFIX +"/sales/printInvoiceShop.vue")
  },
  /** ==== End Sale management ======= */


  /** ==== Stock Transfer ======= */
  {
    path: "/" + PREFIX + "/agri-input/stock-transfer/stock-transfer-request",
    name: PREFIX + ".agri-input.stock-transfer.stock-transfer-request",
    meta: {
      breadCrumb: "requestStockTransfer",
      roles: ""
    },
    component: () => import("../views/"+ PREFIX +"/stockTransfers/stockTransferRequest.vue")
  },
  {
    path: "/" + PREFIX + "/agri-input/stock-transfer/stock-transfer-receive",
    name: PREFIX + ".agri-input.stock-transfer.stock-transfer-receive",
    meta: {
      breadCrumb: "receiveStockTransfer",
      roles: ""
    },
    component: () => import("../views/"+ PREFIX +"/stockTransfers/stockTransferReceive.vue")
  },
  {
    path: "/" + PREFIX + "/agri-input/stock-transfer/stock-transfer-print",
    name: PREFIX + ".agri-input.stock-transfer.stock-transfer-print",
    meta: {
      breadCrumb: "print",
      roles: ""
    },
    component: () => import("../views/"+ PREFIX +"/stockTransfers/stockTransferPrint.vue")
  },
  {
    path: "/" + PREFIX + "/agri-input/stock-transfer/receive-transaction-paid",
    name: PREFIX + ".agri-input.stock-transfer.receive-transaction-paid",
    meta: {
      breadCrumb: "paidInvoice",
      roles: ""
    },
    component: () => import("../views/"+ PREFIX +"/stockTransfers/receiveTransactionPaid.vue")
  },


  /** ==== End Stock Transfer ======= */
    {
      path: "/" + PREFIX + "/agri-input/stock-reconcile/stock-reconcile",
      name: PREFIX + ".agri-input.stock-reconcile.stock-reconcile",
      meta: {
        breadCrumb: "stockReconcile",
        roles: ""
      },
      component: () => import("../views/"+ PREFIX +"/reports/stockReconcile.vue")
    },
    {
      path: "/" + PREFIX + "/agri-input/stock-reconcile/stock-reconcile-list",
      name: PREFIX + ".agri-input.stock-reconcile.stock-reconcile-list",
      meta: {
        breadCrumb: "stockList",
        roles: ""
      },
      component: () => import("../views/"+ PREFIX +"/reports/stockReconcileList.vue")
    },
    {
      path: "/" + PREFIX + "/agri-input/stock-reconcile/stock-reconcile-invoice",
      name: PREFIX + ".agri-input.stock-reconcile.stock-reconcile-invoice",
      meta: {
        breadCrumb: "invoice",
        roles: ""
      },
      component: () => import("../views/"+ PREFIX +"/reports/stockReconcileInvoiceList.vue")
    },
    {
      path: "/" + PREFIX + "/agri-input/stock-reconcile/stock-reconcile-invoice-print",
      name: PREFIX + ".agri-input.stock-reconcile.stock-reconcile-invoice-print",
      meta: {
        breadCrumb: "print",
        roles: ""
      },
      component: () => import("../views/"+ PREFIX +"/reports/stockReconcileInvoicePrint.vue")
    },

  /** ==== Stock Reconcile ======= */


  /** ==== End Stock Reconcile ======= */

  /** ==== Report ======= */
  {
    path: "/" + PREFIX + "/agri-input/reporting/report",
    name: PREFIX + ".agri-input.reporting.report",
    meta: {
      breadCrumb: "reporting",
      roles: ""
    },
    component: () => import("../views/"+ PREFIX +"/reports/report.vue")
  },
  {
    path: "/" + PREFIX + "/agri-input/reporting/stock-reconcile-detail",
    name: PREFIX + ".agri-input.reporting.stock-reconcile-detail",
    meta: {
      breadCrumb: "StockReconcileDetail",
      roles: ""
    },
    component: () => import("../views/"+ PREFIX +"/reports/stockReconcileDetail.vue")
  },
  {
    path: "/" + PREFIX + "/agri-input/reporting/stock-report/:token",
    name: PREFIX + ".agri-input.reporting.stock-report",
    meta: {
      breadCrumb: "StockReport",
      roles: ""
    },
    component: () => import("../views/"+ PREFIX +"/reports/stockReport.vue")
  },
  {
    path: "/" + PREFIX + "/agri-input/reporting/supplier-stock-report/:token",
    name: PREFIX + ".agri-input.reporting.supplier-stock-report",
    meta: {
      breadCrumb: "Supplier Stock Report",
      roles: ""
    },
    component: () => import("../views/"+ PREFIX +"/reports/supplierStockReport.vue")
  },
  {
    path: "/" + PREFIX + "/agri-input/reporting/stock-detail-report/:token",
    name: PREFIX + ".agri-input.reporting.stock-detail-report",
    meta: {
      breadCrumb: "stockDetailReport",
      roles: ""
    },
    component: () => import("../views/"+ PREFIX +"/reports/stockDetailReport.vue")
  },
  {
    path: "/" + PREFIX + "/agri-input/reporting/payment-list-report/:token",
    name: PREFIX + ".agri-input.reporting.payment-list-report",
    meta: {
      breadCrumb: "paymentListReport",
      roles: ""
    },
    component: () => import("../views/"+ PREFIX +"/reports/paymentListReport.vue")
  },
  {
    path: "/" + PREFIX + "/agri-input/reporting/payment-report/:token",
    name: PREFIX + ".agri-input.reporting.payment-report",
    meta: {
      breadCrumb: "paymentReport",
      roles: ""
    },
    component: () => import("../views/"+ PREFIX +"/reports/paymentReport.vue")
  },
  {
    path: "/" + PREFIX + "/agri-input/reporting/sale-transaction-report/:token",
    name: PREFIX + ".agri-input.reporting.sale-transaction-report",
    meta: {
      breadCrumb: "saleTransactionReport",
      roles: ""
    },
    component: () => import("../views/"+ PREFIX +"/reports/saleTransactionReport.vue")
  },
  {
    path: "/" + PREFIX + "/agri-input/reporting/stock-balance-report/:token",
    name: PREFIX + ".agri-input.reporting.stock-balance-report",
    meta: {
      breadCrumb: "stockBalanceReport",
      roles: ""
    },
    component: () => import("../views/"+ PREFIX +"/reports/stockBalanceReport.vue")
  },
  /** ==== End Report ======= */


  /** ==== Buyback ======= */
  {
    path: "/" + PREFIX + "/buyback/buyback-facilitate/request-drawdown",
    name: PREFIX + ".buyback.buyback-facilitate.request-drawdown",
    meta: {
      breadCrumb: "requestDrawDown",
      roles: ""
    },
    component: () => import("../views/" + PREFIX + "/buybacks/requestDrawDown.vue")
  },
  {
    path: "/" + PREFIX + "/buyback/buyback-facilitate/request-drawdown-print",
    name: PREFIX + ".buyback.buyback-facilitate.request-drawdown-print",
    meta: {
      breadCrumb: "requestDrawDown",
      roles: ""
    },
    component: () => import("../views/" + PREFIX + "/buybacks/requestDrawDownPrint.vue")
  },
  {
    path: "/" + PREFIX + "/buyback/buyback-facilitate/buyback-transaction",
    name: PREFIX + ".buyback.buyback-facilitate.buyback-transaction",
    meta: {
      breadCrumb: "createInvoice",
      roles: ""
    },
    component: () => import("../views/" + PREFIX + "/buybacks/buybackTransaction.vue")
  },
  {
    path: "/" + PREFIX + "/buyback/buyback-facilitate/buyback-payment-board",
    name: PREFIX + ".buyback.buyback-facilitate.buyback-payment-board",
    meta: {
      breadCrumb: "payment",
      roles: ""
    },
    component: () => import("../views/" + PREFIX + "/buybacks/buybackPaymentBoard.vue")
  },
  {
    path: "/" + PREFIX + "/buyback/buyback-facilitate/buyback-transaction-paid",
    name: PREFIX + ".buyback.buyback-facilitate.buyback-transaction-paid",
    meta: {
      breadCrumb: "paidInvoice",
      roles: ""
    },
    component: () => import("../views/" + PREFIX + "/buybacks/buybackTransactionPaid.vue")
  },
  {
    path: "/" + PREFIX + "/buyback/buyback-facilitate/buyback-print",
    name: PREFIX + ".buyback.buyback-facilitate.buyback-print",
    meta: {
      breadCrumb: "print",
      roles: ""
    },
    component: () => import("../views/" + PREFIX + "/buybacks/buybackPrint.vue")
  },
  {
    path: "/" + PREFIX + "/buyback/buyback-facilitate/buyback-report",
    name: PREFIX + ".buyback.buyback-facilitate.buyback-report",
    meta: {
      breadCrumb: "report",
      roles: ""
    },
    component: () => import("../views/" + PREFIX + "/buybacks/buybackReport.vue")
  },
  {
    path: "/" + PREFIX + "/buyback/buyback-invoice-financing/request-drawdown-creditline",
    name: PREFIX + ".buyback.buyback-invoice-financing.request-drawdown-creditline",
    meta: {
      breadCrumb: "requestDrawDownCreditLine",
      roles: ""
    },
    component: () => import("../views/" + PREFIX + "/buybacks/requestDrawDownCreditline.vue")
  },
  {
    path: "/" + PREFIX + "/buyback/buyback-invoice-financing/request-drawdown-creditline-print",
    name: PREFIX + ".buyback.buyback-invoice-financing.request-drawdown-creditline-print",
    meta: {
      breadCrumb: "requestDrawDownCreditLine",
      roles: ""
    },
    component: () => import("../views/" + PREFIX + "/buybacks/requestDrawDownCreditlinePrint.vue")
  },
  {
    path: "/" + PREFIX + "/buyback/buyback-trading/crop-collect-planing",
    name: PREFIX + ".buyback.buyback-trading.crop-collect-planing",
    meta: {
      breadCrumb: "cropCollectPlaning",
      roles: ""
    },
    component: () => import("../views/" + PREFIX + "/buybacks/buybackCropCollectPlaning.vue")
  },
  {
    path: "/" + PREFIX + "/buyback/buyback-trading/invoice-draft",
    name: PREFIX + ".buyback.buyback-trading.invoice-draft",
    meta: {
      breadCrumb: "invoiceDraft",
      roles: ""
    },
    component: () => import("../views/" + PREFIX + "/buybacks/buybackInvoiceDraft.vue")
  },
  {
    path: "/" + PREFIX + "/buyback/buyback-trading/invoice-draft-print",
    name: PREFIX + ".buyback.buyback-trading.invoice-draft-print",
    meta: {
      breadCrumb: "invoiceDraft",
      roles: ""
    },
    component: () => import("../views/" + PREFIX + "/buybacks/buybackInvoiceDraftPrint.vue")
  },
  {
    path: "/" + PREFIX + "/buyback/buyback-trading/purchase",
    name: PREFIX + ".buyback.buyback-trading.purchase",
    meta: {
      breadCrumb: "purchase_paddy",
      roles: ""
    },
    component: () => import("../views/" + PREFIX + "/buybacks/buybackPurchase.vue")
  },
  {
    path: "/" + PREFIX + "/buyback/buyback-trading/payment-vourcher",
    name: PREFIX + ".buyback.buyback-trading.payment-vourcher",
    meta: {
      breadCrumb: "paymentVourcher",
      roles: ""
    },
    component: () => import("../views/" + PREFIX + "/buybacks/buybackPaymentVourcher.vue")
  },
  {
    path: "/" + PREFIX + "/buyback/buyback-trading/sale",
    name: PREFIX + ".buyback.buyback-trading.sale",
    meta: {
      breadCrumb: "sale_paddy",
      roles: ""
    },
    component: () => import("../views/" + PREFIX + "/buybacks/buybackSale.vue")
  },
  {
    path: "/" + PREFIX + "/buyback/buyback-trading/receipt-vourcher",
    name: PREFIX + ".buyback.buyback-trading.receipt-vourcher",
    meta: {
      breadCrumb: "receiptVourcher",
      roles: ""
    },
    component: () => import("../views/" + PREFIX + "/buybacks/buybackReceiptVourcher.vue")
  },
  {
    path: "/" + PREFIX + "/buyback/revolving-credit/request_drawdown_revolving_credit",
    name: PREFIX + ".buyback.revolving-credit.request_drawdown_revolving_credit",
    meta: {
      breadCrumb: "requestDrawDownRevolvingCredit",
      roles: ""
    },
    component: () => import("../views/" + PREFIX + "/revolvingCredits/drawDownRevolvingCredit.vue")
  },
  {
    path: "/" + PREFIX + "/buyback/revolving-credit/revolving-credit-print",
    name: PREFIX + ".buyback.revolving-credit.revolving-credit-print",
    meta: {
      breadCrumb: "",
      roles: ""
    },
    component: () => import("../views/" + PREFIX + "/revolvingCredits/revolvingCreditPrint.vue")
  },
  {
    path: "/" + PREFIX + "/buyback/buyback-trading/bill-invoice-print",
    name: PREFIX + ".buyback.buyback-trading.bill-invoice-print",
    meta: {
      breadCrumb: "print",
      roles: ""
    },
    component: () => import("../views/" + PREFIX + "/buybacks/buybackBillInvoicePrint.vue")
  },
  {
    path: "/" + PREFIX + "/buyback/buyback-trading/payment-receipt-vourcher-print",
    name: PREFIX + ".buyback.buyback-trading.payment-receipt-vourcher-print",
    meta: {
      breadCrumb: "print",
      roles: ""
    },
    component: () => import("../views/" + PREFIX + "/buybacks/buybackPaymentReceiptVourcherPrint.vue")
  },
  /** ==== End Buyback ======= */

  /** ==== Outside Business ======= */
  {
    path: "/" + PREFIX + "/outside-business/sale",
    name: PREFIX + ".outside-business.sale",
    meta: {
      breadCrumb: "sale",
      roles: ""
    },
    component: () => import("../views/" + PREFIX + "/outsideBusinesses/sale.vue")
  },
  {
    path: "/" + PREFIX + "/outside-business/purchasing",
    name: PREFIX + ".outside-business.purchasing",
    meta: {
      breadCrumb: "purchasing",
      roles: ""
    },
    component: () => import("../views/" + PREFIX + "/outsideBusinesses/purchasing.vue")
  },
  {
    path: "/" + PREFIX + "/outside-business/stock-reconcile",
    name: PREFIX + ".outside-business.stock-reconcile",
    meta: {
      breadCrumb: "stockReconcile",
      roles: ""
    },
    component: () => import("../views/" + PREFIX + "/outsideBusinesses/stockReconcile.vue")
  },
  {
    path: "/" + PREFIX + "/outside-business/stock-list",
    name: PREFIX + ".outside-business.stock-list",
    meta: {
      breadCrumb: "stockList",
      roles: ""
    },
    component: () => import("../views/" + PREFIX + "/outsideBusinesses/stockList.vue")
  },
  {
    path: "/" + PREFIX + "/outside-business/stock-registration",
    name: PREFIX + ".outside-business.stock-registration",
    meta: {
      breadCrumb: "stockRegistration",
      roles: ""
    },
    component: () => import("../views/" + PREFIX + "/outsideBusinesses/stockRegistration.vue")
  },
  {
    path: "/" + PREFIX + "/outside-business/sale-print",
    name: PREFIX + ".outside-business.sale-print",
    meta: {
      breadCrumb: "print",
      roles: ""
    },
    component: () => import("../views/" + PREFIX + "/outsideBusinesses/salePrint.vue")
  },
  {
    path: "/" + PREFIX + "/outside-business/stock-reconcile-detail",
    name: PREFIX + ".outside-business.stock-reconcile-detail",
    meta: {
      breadCrumb: "print",
      roles: ""
    },
    component: () => import("../views/" + PREFIX + "/outsideBusinesses/stockReconcileDetail.vue")
  },
  {
    path: "/" + PREFIX + "/outside-business/sale-paid",
    name: PREFIX + ".outside-business.sale-paid",
    meta: {
      breadCrumb: "paidInvoice",
      roles: ""
    },
    component: () => import("../views/" + PREFIX + "/outsideBusinesses/salePaid.vue")
  },
  /** ==== End Outside Business ======= */

  /** ==== Membership ======= */
  {
    path: "/" + PREFIX + "/membership/list-membership",
    name: PREFIX + ".membership.list-membership",
    meta: {
      breadCrumb: "listMembership",
      roles: ""
    },
    component: () => import("../views/" + PREFIX + "/memberships/listMembership.vue")
  },

  /** ==== Settings ======= */
  {
    path: "/" + PREFIX + "/setting/product",
    name: PREFIX + ".setting.product",
    meta: {
      breadCrumb: "product",
      roles: ""
    },
    component: () => import("../views/" + PREFIX + "/settings/product.vue")
  },
  {
    path: "/" + PREFIX + "/setting/unit",
    name: PREFIX + ".setting.unit",
    meta: {
      breadCrumb: "unit",
      roles: ""
    },
    component: () => import("../views/" + PREFIX + "/settings/unit.vue")
  },
  {
    path: "/" + PREFIX + "/setting/category",
    name: PREFIX + ".setting.category",
    meta: {
      breadCrumb: "category",
      roles: ""
    },
    component: () => import("../views/" + PREFIX + "/settings/category.vue")
  },
];